import LandingPage from "../../pages/LandingPage";

export const ROUTES = {
  LandingPage: '/straygames',
  HOME: '/home',
  Services: '/Services',
  About: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  GAME_LIBRARY: '/library',
  STREAM: '/stream/:gameId',
  SUBSCRIPTION: '/subscription',
  PROFILE: '/profile',
  SUCCESS: '/success',
  CANCEL: '/cancel',
};

export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.REGISTER];